export enum OrderStatusEnum {
  pendent = 1,
  sent = 2,
  inProcess = 3,
  partiallyDelivered = 4,
  received = 5,
  all = 0,
  finished = 9999,
}
